import { PROJECT_STATUS } from "@/interfaces/project_types"

export const isValidStatus = (status: string | undefined): status is typeof PROJECT_STATUS[number] => {
    return PROJECT_STATUS.includes(status as typeof PROJECT_STATUS[number])
}
